module.exports = __webpack_public_path__ + "img/40_38_032_650.af1d98d5.jpg";